import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { SecondaryMenuItemTitle } from './SecondaryMenuTitles';

type NumberInputBoxSingleColProps = {
  title?: string;
  descriptionText?: string;
  onChange: (val: number) => void;
  onBlur?: (val: number) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  startAdornmentText?: string;
  endAdornmentText?: string;
  value?: number;
  error?: string;
  testId?: string;
};

export const NumberInputBoxSingleCol = ({
  onChange,
  onBlur,
  onFocus,
  title = 'title',
  descriptionText,
  startAdornmentText = '',
  endAdornmentText = '',
  value = 0,
  error,
  testId,
}: NumberInputBoxSingleColProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const positiveNum = Math.abs(Number(event.target.value) || 0);
    onChange(positiveNum);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      const positiveNum = Math.abs(Number(event.target.value) || 0);
      onBlur(positiveNum);
      event.target.blur();
    }
  };

  const isError = !!error;
  return (
    <Grid container direction="column" rowGap={1}>
      <SecondaryMenuItemTitle>{title}</SecondaryMenuItemTitle>
      <Grid item width={'100%'}>
        <FormControl variant="outlined" color="secondary" size="small" fullWidth data-testid={testId}>
          <OutlinedInput
            type="number"
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                (e.target as HTMLInputElement).blur();
              }
            }}
            error={isError}
            value={value.toString()}
            startAdornment={<InputAdornment position="start">{startAdornmentText}</InputAdornment>}
            endAdornment={<InputAdornment position="end">{endAdornmentText}</InputAdornment>}
            sx={{
              '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
            }}
          />
        </FormControl>
      </Grid>
      {descriptionText || error ? (
        <Box component="p" fontSize={12} lineHeight={1.5} letterSpacing={0.18} color={isError ? 'red' : '#353636'}>
          {isError ? error : descriptionText}
        </Box>
      ) : null}
    </Grid>
  );
};
